module.exports = __webpack_public_path__ + "static/0111-8491142e5f7a2422821cfb0fd37dbdcb.png";